/* ── Mobile Menu Toggle ── */

const toggle = document.querySelector(".menu-toggle");
const nav = document.querySelector(".site-nav");

if (toggle && nav) {
  toggle.addEventListener("click", () => {
    const isOpen = nav.classList.toggle("is-open");
    toggle.setAttribute("aria-expanded", String(isOpen));
  });

  nav.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => {
      // On mobile a dropdown trigger only expands its submenu, so it must not
      // close the menu it is expanding inside of.
      if (link.classList.contains("nav-dropdown-trigger") && window.innerWidth <= 1280) {
        return;
      }
      nav.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
    });
  });
}

/* ── Mobile Nav Dropdown Toggle ── */

document.querySelectorAll(".nav-dropdown-trigger").forEach((trigger) => {
  trigger.addEventListener("click", (e) => {
    // Only toggle on mobile (when menu-toggle is visible)
    if (window.innerWidth <= 1280) {
      e.preventDefault();
      const isOpen = trigger.closest(".nav-dropdown").classList.toggle("is-open");
      trigger.setAttribute("aria-expanded", String(isOpen));
    }
  });
});

/* ── Announcement Bar ── */

const announcementBar = document.getElementById("announcement-bar");
const announcementClose = document.querySelector(".announcement-close");

if (announcementBar && announcementClose) {
  if (localStorage.getItem("ss-announcement-dismissed") === "true") {
    announcementBar.classList.add("is-hidden");
  }

  announcementClose.addEventListener("click", () => {
    announcementBar.classList.add("is-hidden");
    localStorage.setItem("ss-announcement-dismissed", "true");
  });
}

/* ── Reservation Link Routing ── */

const tockAnchorId = "tock-reservations";
const reservationProductPattern = /\/products\/mothers-day-weekend-afternoon-tea/i;
const reservationLabelPattern =
  /^(reserve|reservations|book a sitting|reserve a sitting|reserve your seat)$/i;

function getTockReservationUrl() {
  const brandLink = document.querySelector(".brand");
  const homeUrl = new URL(brandLink?.getAttribute("href") || "/", window.location.origin);
  homeUrl.hash = tockAnchorId;
  return homeUrl.toString();
}

function shouldRouteToTock(link) {
  const href = link.getAttribute("href") || "";
  const label = (link.textContent || "").trim();

  if (reservationProductPattern.test(href)) {
    return true;
  }

  if (reservationLabelPattern.test(label) && href.includes("/pages/menu-mothers-day")) {
    return true;
  }

  return false;
}

const tockReservationUrl = getTockReservationUrl();

document.querySelectorAll("a[href]").forEach((link) => {
  if (shouldRouteToTock(link)) {
    link.setAttribute("href", tockReservationUrl);
    if (link.getAttribute("target") === "_blank") {
      link.removeAttribute("target");
      link.removeAttribute("rel");
    }
  }
});

/* ── Hash Scroll Offset (compensate for sticky header on page load) ── */

if (window.location.hash) {
  requestAnimationFrame(() => {
    const target = document.querySelector(window.location.hash);
    if (target) {
      const header = document.querySelector(".site-header");
      const offset = header ? header.offsetHeight + 20 : 120;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  });
}

/* ── Scroll Reveal ── */

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      }
    });
  },
  {
    threshold: 0.16,
  }
);

document.querySelectorAll(".reveal").forEach((element) => observer.observe(element));
